/**
 * Swiper 5 卸载时 el / touchEvents 可能已空，
 * destroy() 内部访问会抛 removeEventListener / n.start。
 */
export function safeDestroySwiper(swiper) {
  if (!swiper || swiper.destroyed || typeof swiper.destroy !== 'function') {
    return null;
  }
  try {
    swiper.destroy();
  } catch (e) {
    // 实例已残缺时忽略即可，组件马上卸载
  }
  return null;
}
